import styled, { css } from 'styled-components';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import { getIcon } from 'styles/icons';
import CustomLink from 'components/Globals/Base/Link';

const arrowEnabled = css<{ theme: Theme }>`
  &:hover,
  &:focus {
    border-color: ${getColor('iconAccentPrimary')};
  }
  &:active {
    border-color: ${getColor('iconAccentPrimary')};
  }
`;

const arrowDisabled = css<{ theme: Theme }>`
  border-color: ${getColor('iconSecondary')};
`;

const arrow = css<{ theme: Theme; $isDisabled?: boolean }>`
  border-color: ${getColor('iconPrimary')};
  margin-bottom: 0;  

  ${({ $isDisabled }) => ($isDisabled ? arrowDisabled : arrowEnabled)}
`;

export const PreviousArrow = styled.span<{ theme: Theme; $isDisabled?: boolean }>`
  ${getIcon('prev-arrow')}
  ${arrow}
`;

export const NextArrow = styled.span<{ theme: Theme; $isDisabled?: boolean }>`
 ${getIcon('next-arrow')}
 ${arrow} 
`;

export const ArrowLink = styled(CustomLink)`
  &[aria-disabled='true'] {
    cursor: default;
    pointer-events: none;
  }
`;

export const PageLink = styled(CustomLink)<{ theme: Theme }>`
  &:active,
  &:active > *:not(.no-active) {
    color: ${getColor('textAccentPrimary')};
    text-decoration: none;
  }
  &[aria-current='page'] {
    cursor: default;
    pointer-events: none;
  }
`;

export const HiddenLi = styled.li`
  display: none;
`;

export const PaginationList = styled.ul<{ theme: Theme }>`
  align-items: center;
  display: flex;
  justify-content: center;
  list-style: none;
  gap: 24px;
  ${getBodyStyle('graphikCond', { default: 'default' }, 'semiBold')};
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-top: 60px;  
`;
